export const Login2Routing = {
  path: "/login2",
  name: "login2",
  meta: { title: "工程企业管理软件" },
  component: () => import(/* webpackChunkName: "login" */ "@/views/login2/index.vue"),
  children: [],
};
